import { ASSISTANT_PENDING_TEXT } from '@/constants/chat'
import { createId } from '@/features/chat/chatIds'
import { pendingAgentMeta } from './pendingAgentMeta'

/** @param {{ trimmed: string, files?: unknown[], exchangeId?: string | null, versionIndex: number, assistantVersionIndex?: number, now: number, includeAgentMeta?: boolean }} o */
export function buildUserAndPendingMessages(o) {
  const {
    trimmed,
    files,
    exchangeId = null,
    versionIndex,
    assistantVersionIndex = 0,
    now,
    includeAgentMeta = false,
  } = o
  const userMsg = {
    id: createId(),
    role: 'user',
    text: trimmed,
    ...(files !== undefined ? { files: files || [] } : {}),
    createdAt: now,
    exchangeId,
    versionIndex,
  }
  if (exchangeId === null) userMsg.exchangeId = userMsg.id
  const pendingId = createId()
  const pendingAssistant = {
    id: pendingId,
    role: 'assistant',
    text: ASSISTANT_PENDING_TEXT,
    createdAt: now,
    thinkingStartedAt: now,
    exchangeId: exchangeId ?? userMsg.exchangeId,
    versionIndex,
    assistantVersionIndex,
    ...(includeAgentMeta ? pendingAgentMeta(trimmed) : {}),
  }
  return { userMsg, pendingId, pendingAssistant }
}
